module.exports = __webpack_public_path__ + "static/media/checkmark_circle.531c8a21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/checkmark_circle.svg
// module id = 209
// module chunks = 21